import View from '@ckeditor/ckeditor5-ui/src/view';


export default class FAIconView extends View {
    /**
     * @inheritDoc
     */
    constructor() {
        super();

        /**
         * The SVG source of the icon.
         *
         * @observable
         * @member {String} #content
         */
        this.set( 'content', '' );

        this.setTemplate( {
            tag: 'i',
            attributes: {
                class: [
                    'ck',
                    'ck-fa-icon'
                ]
            }
        } );
    }

    /**
     * @inheritDoc
     */
    render() {
        super.render();

        this._updateContent();

        // This is a hack for lack of innerHTML binding.
        // See: https://github.com/ckeditor/ckeditor5-ui/issues/99.
        this.on( 'change:content', () => {
            this._updateContent();
        } );
    }

    /**
     * Updates the {@link #element} with the value of {@link #content}.
     *
     * @private
     */
    _updateContent() {
        if ( this.content ) {
            this.element.className = 'ck ck-fa-icon ' + this.content;
        }
    }
}
